import React from 'react';
import './ShopCard.scss';
import { Button } from 'antd';
import { ReactComponent as FrogIcon } from 'assets/icons/FrogIcon.svg';

export interface ShopCardProps {
    name: string;
    imageURL: string;
    price: number;
    available: boolean;
    purchased: boolean;
    onClick: () => void;
}

function ShopCard({
    name,
    imageURL,
    price,
    available,
    purchased,
    onClick,
}: ShopCardProps): React.ReactElement {
    const inactive = React.useRef(purchased || available);

    return (
        <div className={`shop-card ${+inactive.current || 'unavailable'}`}>
            <img src={imageURL} alt="" className="shop-card_image" />
            <div className="shop-card_content">
                <h2 className="chop-card_name">{name}</h2>
                <div className="shop-card_price">
                    {price} <FrogIcon />
                </div>
                <Button
                    type="primary"
                    danger={purchased}
                    disabled={!inactive.current}
                    onClick={onClick}
                >
                    {purchased ? 'Отменить' : 'Приобрести'}
                </Button>
            </div>
        </div>
    );
}

export default React.memo(ShopCard);
